const user = {
  state: {
    token: '',
    id: '',
    name: '',
    username: ''
  },

  // 브라우저에 Token, 이름, 권한 등을 설정하는 함수
  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_ID: (state, id) => {
      state.id = id
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_USERNAME: (state, username) => {
      state.username = username
    }
  },

  actions: {
    setToken ({ commit }, token) {
      commit('SET_TOKEN', token)
    },
    setId ({ commit }, id) {
      commit('SET_ID', id)
    },
    setName ({ commit }, name) {
      commit('SET_NAME', name)
    },
    setUsername ({ commit }, username) {
      commit('SET_USERNAME', username)
    }
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js